import styled from 'styled-components';

export const ThreadCardStyled = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 20px;
  margin: 0;
  border-radius: 22px;
  border: 1px solid var(--line);
  background: var(--card);
  color: var(--ink);
  box-shadow: var(--shadow);
  transition:
    border-color 0.2s var(--ease),
    box-shadow 0.2s var(--ease);
  overflow: hidden;

  &:hover {
    border-color: var(--o1);
    box-shadow: var(--shadow-lg);
  }

  .thread-row {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    min-width: 0;
  }

  .icon-btn {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--o-tint);
    color: var(--o2);
    cursor: pointer;
    padding: 0;
  }

  .text-box {
    flex: 1;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-align: left;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    color: var(--quiet);

    .title {
      display: block;
      width: 100%;
      max-width: 100%;
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
      margin: 0 0 6px;
      text-transform: capitalize;
      color: var(--ink);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
    }
  }

  .card-menu {
    flex-shrink: 0;
  }

  .card-footer {
    padding: 12px 0 0 56px;
    min-width: 0;

    .date {
      display: block;
      font-size: 12px;
      color: var(--quiet);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;
